import styled from "styled-components";

const calcRight = (markWidth) => {
  const width = markWidth / 2;
  return `calc(50% - ${width}px)`;
};

const calcTop = (markHeight) => {
  const height = markHeight / 2;
  return `calc(50% - ${height}px)`;
};

export const MapCenterStyled = styled.div`
  z-index: 2;
  right: ${(props) => calcRight(props.markWidth)};
  top: ${(props) => calcTop(props.markHeight)};

  margin-right: -5px;
  margin-top: -10px;
`;
